import React from "react";

const Header = () => {
  return (
    <header className="bg-gradient-to-r from-orange-400 to-red-500 text-white py-3 text-center">
      <h1 className="text-xl font-bold">🔥 LAST UNITS LEFT!</h1>
    </header>
  );
};

export default Header;
